
import { map, filter, mergeMap } from 'rxjs/operators'
import { Epic } from 'interfaces/middleware'
import { combineEpics } from 'redux-observable'
import {
  UPDATE_NAVIGATION_COUNTERS,
  stashNavigationCountersActionCreator,
  setNavigationCountersActionCreator,
  UNSTASH_NAVIGATION_COUNTERS,
  unstashNavigationCountersActionCreator,
} from 'actions/sidebarActions'
import { isOpportunityPage } from 'helpers/opportunityHelpers'
import { stashCountersSelector } from 'selectors/sidebarSelectors'
import { of } from 'rxjs'
import { Action } from 'actions'
import { PAGE_CHANGED } from 'actions/globalActions'
import { OPPORTUNITIES_URL } from 'tangle-shared'
import { byType } from 'rxOperators/byType'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'

const updateCountersEpic: Epic = (action$, store) =>
  action$
    .pipe(byType(UPDATE_NAVIGATION_COUNTERS)).pipe(
      mergeMap((action) => {
        const actions: Action[] = []
        const state = store.getState()

        const hasOpportunityCounter = state.app.sidebar.counters.actual.unseen_opportunities !== undefined
        const preventOpportunityCounterUpdate = isOpportunityPage() && hasOpportunityCounter

        let { payload } = action
        let unseen_opportunities: number | undefined

        if (preventOpportunityCounterUpdate) {
          ({ unseen_opportunities, ...payload } = action.payload)

          if (unseen_opportunities !== undefined) {
            actions.push(stashNavigationCountersActionCreator({ unseen_opportunities }))
          }
        }

        actions.push(setNavigationCountersActionCreator(payload))
        return of(...actions)
      }))

const unstashCountersEpic: Epic = (action$, store) =>
  action$
    .pipe(filterRequestOfType(UNSTASH_NAVIGATION_COUNTERS, 'request')).pipe(
      mergeMap(() => {
        const state = store.getState()
        const { unseen_opportunities } = stashCountersSelector(state)

        const actions: Action[] = []
        if (unseen_opportunities !== undefined) {
          actions.push(setNavigationCountersActionCreator({ unseen_opportunities }))
        }

        actions.push(unstashNavigationCountersActionCreator.success({}, {}))

        return of(...actions)
      }))

const leaveOpportunitiesPageEpic: Epic = (action$, store) =>
  action$
    .pipe(byType(PAGE_CHANGED)).pipe(
      filter(({ payload }) => payload.prev === OPPORTUNITIES_URL && payload.next !== OPPORTUNITIES_URL),
      map(() => store.getState()),
      filter((state) => state.app.sidebar.counters.stash.unseen_opportunities !== undefined),
      map(() => unstashNavigationCountersActionCreator.request({})))

export const sidebarEpic = combineEpics(
  updateCountersEpic,
  unstashCountersEpic,
  leaveOpportunitiesPageEpic,
)
